var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailFill = function SvgMailFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.95 2.25h8.1a.45.45 0 0 1 .45.45v6.6a.45.45 0 0 1-.45.45h-8.1a.45.45 0 0 1-.45-.45V2.7a.45.45 0 0 1 .45-.45m4.077 3.907-2.885-2.45-.583.686 3.474 2.95L9.444 4.39l-.588-.681-2.829 2.447Z"
  })));
};
export default SvgMailFill;